import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type HrisInstallService from 'garaje/services/hris-install';
import { Permission } from 'garaje/utils/ui-permissions';

export default class HrisDashboardAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare hrisInstall: HrisInstallService;

  // Company-level read → global overview (can see all locations)
  get canVisitGlobal(): boolean {
    if (!this.featureFlags.isEnabled('integration-hris-dashboard')) return false;
    this.hrisInstall.ensureLoaded();
    if (!this.hrisInstall.isInstalled) return false;
    return this.authz.hasPermissionAtCurrentCompany(Permission.HRIS_LIFECYCLE_ROUTINE_READ);
  }

  // Any read permission → can visit the dashboard
  get canVisit(): boolean {
    const ff = this.featureFlags.isEnabled('integration-hris-dashboard');
    if (!ff) return false;
    this.hrisInstall.ensureLoaded();
    if (!this.hrisInstall.isInstalled) return false;
    return (
      this.authz.hasPermissionAtCurrentCompany(Permission.HRIS_LIFECYCLE_ROUTINE_READ) ||
      this.authz.hasPermissionAtCurrentLocation(Permission.HRIS_LIFECYCLE_ROUTINE_READ)
    );
  }

  // Location-level manage → can write at current location
  get canManage(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.HRIS_LIFECYCLE_ROUTINE_MANAGE);
  }

  // Company-level manage → can write globally
  get canManageAll(): boolean {
    return this.authz.hasPermissionAtCurrentCompany(Permission.HRIS_LIFECYCLE_ROUTINE_MANAGE);
  }
}
